import { memo } from 'react';
import { compactNumber } from '../utils/formatNumber';
import './MapHud.css';

/**
 * History-map counter HUD — same single instrument strip as the Live map
 * (MapHud.css), with History's own stat set. Every item always renders so the
 * strip never resizes.
 */
function HistoryStatsOverlay({
  totalAircraft = 0,
  totalMessages = 0,
  newAircraft = 0,
  regularAircraft = 0,
  militaryCount = 0,
  maxDistance = 0,
  distanceUnit = 'km',
  loading = false
}) {
  if (loading) return null;

  return (
    <div className="map-hud">
      <div className="map-hud-item">
        <span className="map-hud-l">Acft</span>
        <span className="map-hud-v">{compactNumber(totalAircraft)}</span>
      </div>
      <div className="map-hud-item">
        <span className="map-hud-l">Msgs</span>
        <span className="map-hud-v">{compactNumber(totalMessages)}</span>
      </div>
      <div className="map-hud-item new">
        <span className="map-hud-l">New</span>
        <span className="map-hud-v">{compactNumber(newAircraft)}</span>
      </div>
      <div className="map-hud-item">
        <span className="map-hud-l">Reg</span>
        <span className="map-hud-v">{compactNumber(regularAircraft)}</span>
      </div>
      <div className="map-hud-item">
        <span className="map-hud-l">Mil</span>
        <span className="map-hud-v">{compactNumber(militaryCount)}</span>
      </div>
      <div className="map-hud-item">
        <span className="map-hud-l">Max&nbsp;{distanceUnit}</span>
        <span className="map-hud-v">{maxDistance.toFixed(1)}</span>
      </div>
    </div>
  );
}

export default memo(HistoryStatsOverlay);
